import React, { useState } from 'react';
import {
  Container, Typography, Button, Grid,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Popup from '../componant/Popup';
import image1 from '../images/number1-Icon.87c7b61e.svg';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    background: 'linear-gradient(90deg, rgba(13,71,161,1) 0%, rgba(255,87,34,1) 100%)',
    color: 'white',
    textAlign: 'center',
    padding: '20px 0',
  },
  dialogContent: {
    padding: '16px 24px',
  },
  cityButton: {
    width: '100%',
    justifyContent: 'flex-start',
    borderColor: '#233098',
    color: '#233098',
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  cityIcon: {
    color: 'red',
    marginRight: '8px',
  },
  formContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '32px',
    backgroundColor: '#f0f4ff',
  },
  form: {
    width: '100%',
    maxWidth: '600px',
    padding: '32px',
    backgroundColor: 'white',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  },
  submitButton: {
    marginTop: '16px',
    backgroundColor: '#0d47a1',
    color: 'white',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '16px',
    flexDirection: 'column',
    '@media (minWidth:600px)': {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  },
  logoImage: {
    marginBottom: 8,
    width: '80px',
    height: 'auto',
    '@media (minWidth:600px)': {
      marginBottom: 0,
    },
  },
}));

const App = () => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grid sx={{ width: '100%' }}>
      <Container
        sx={{
          textAlign: 'center',
          padding: { xs: '32px 16px', sm: '48px 24px', md: '64px 32px' },
        }}
      >
        <div className={classes.logoContainer}>
          <img src={image1} alt="Number 1 Icon" className={classes.logoImage} />
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontFamily: 'sans-serif',
              fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
              textAlign: 'center',
            }}
          >
            India's Largest Common Application Form For College Admissions
          </Typography>
        </div>
        <Typography
          variant="h2"
          gutterBottom
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            color: '#233098',
          }}
        >
          <span style={{ color: '#f5a041' }}>2000+ Colleges</span>,1 Application Form
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
            color: '#333',
          }}
        >
          Applying to your dream colleges made easy!
        </Typography>
        <Button
          variant="contained"
          sx={{
            marginTop: '32px',
            backgroundColor: '#3f53d9',
            padding: { xs: '8px 16px', sm: '10px 20px' },
            fontSize: { xs: '0.875rem', sm: '1rem' },
            borderRadius: '8px',
          }}
          onClick={handleClickOpen}
        >
          Start Your Application
        </Button>
      </Container>

      {/* AutoPopup Component */}
      <Popup isOpen={open} onClose={handleClose} />
    </Grid>
  );
};

export default App;
